import { render, staticRenderFns } from "./WithdrawalRequests.vue?vue&type=template&id=a6b5af0e&scoped=true"
import script from "./WithdrawalRequests.vue?vue&type=script&lang=js"
export * from "./WithdrawalRequests.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalRequests.vue?vue&type=style&index=0&id=a6b5af0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b5af0e",
  null
  
)

export default component.exports